module.exports = ":host {\n  color: #868e96;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.dropdown ::ng-deep .nav-link {\n  color: #fff; }\n\n.dropdown ::ng-deep .nav-link .navbar-brand {\n    font-size: 1rem;\n    margin-right: 0.5rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dropdown-sort/dropdown-sort.component.scss
// module id = ./src/app/shared/components/dropdown-sort/dropdown-sort.component.scss
// module chunks = main